import { render, staticRenderFns } from "./test-canvas.vue?vue&type=template&id=1063a234&scoped=true&"
import script from "./test-canvas.vue?vue&type=script&lang=js&"
export * from "./test-canvas.vue?vue&type=script&lang=js&"
import style0 from "./test-canvas.vue?vue&type=style&index=0&id=1063a234&lang=scss&scoped=scoped&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1063a234",
  null
  
)

export default component.exports